import { dataAbTestSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAbTestSolid = /*#__PURE__*/createIcon(dataAbTestSolid)
export default IconAbTestSolid
